// Account Receivable Getters

export const getAccountReceivableList = state => {
  return state.accountReceivableList
}

export const getAccountReceivableInfo = state => {
  return state.accountReceivableInfo
}

export const getAccountReceivableBalanceDetails = state => {
  return state.accountReceivableBalanceDetails
}
